import { useCallback } from 'react';
import { useNotification } from '@/hooks';
import { NotificationSeverity } from '@/components/notifications/Notification';
import { getErrorMessage } from '@/utils';
import { useDisableDriverMutation, useEnableDriverMutation } from '../services';

const useDriverStatusActions = () => {
    const { showNotification } = useNotification();
    const [enableDriver, { isLoading: isEnabling }] = useEnableDriverMutation();
    const [disableDriver, { isLoading: isDisabling }] =
        useDisableDriverMutation();

    const onConfirmDriverStatus = useCallback(
        async (driverId: string, nextValue: boolean) => {
            try {
                if (nextValue) {
                    await enableDriver({ id: driverId }).unwrap();
                } else {
                    await disableDriver({ id: driverId }).unwrap();
                }
                showNotification(
                    nextValue
                        ? 'Usuario activado correctamente'
                        : 'Usuario desactivado correctamente',
                    NotificationSeverity.success
                );
                return true;
            } catch (error) {
                const errorMessage = getErrorMessage(
                    error,
                    'Ocurrió un error al actualizar el estado del usuario. Inténtalo nuevamente.'
                );
                showNotification(errorMessage, NotificationSeverity.error);
                return false;
            }
        },
        [disableDriver, enableDriver, showNotification]
    );

    return {
        onConfirmDriverStatus,
        isEnabling: isEnabling || isDisabling,
    };
};

export default useDriverStatusActions;
